// Date and time formatting utilities
export const formatPublishTime = (dateString) => {
  const publishDate = new Date(dateString);
  const now = new Date();
  const diffInMs = now - publishDate;
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  // Show relative time for content within 24 hours
  if (diffInMinutes < 1) {
    return 'Just now';
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
  } else {
    // Show regular date for content older than 24 hours
    return publishDate.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric', 
      year: 'numeric'
    });
  }
};

export const formatAuthorByline = (authorName) => {
  return `BY ${authorName.toUpperCase()}`;
};

// Alternative function for showing relative time everywhere
export const getRelativeTime = (dateString) => {
  const publishDate = new Date(dateString);
  const now = new Date();
  const diffInMs = now - publishDate;
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInMinutes < 1) {
    return 'Just now';
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  } else if (diffInDays < 7) {
    return `${diffInDays}d ago`;
  } else {
    return publishDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  }
};